import React from 'react';
import ReportViewer from "./base/ReportViewer";

const JournalVentes = () => {

    return (
        <div style={{ height: "100%" }}>
            <ReportViewer reportName={"JournalVentesReport"} />
        </div>
    );
}
export default JournalVentes;